import React from 'react';
import { ProductCat } from 'data/e-commerce/products';
import { Col, Row } from 'react-bootstrap';
import { useAppContext } from 'providers/AppProvider';
import ProductCardCat from 'components/common/ProductCardCat';

interface EcomCategoryWiseProductsProps {
  products: ProductCat[];
  category: string;
  counts: number;
}

const EcomCategoriesWisePorduct = ({
  products,
  category,
  counts
}: EcomCategoryWiseProductsProps) => {
  const {
    config: { theme }
  } = useAppContext();

  return (
    <div
      className={`bg-light rounded-3 p-4 ${theme === 'dark' ? 'bg-dark' : ''}`}
    >
      <div className="mb-4">
        <h6 className="mb-6 mt-2 fs-7">
          {category} <span className="text-primary">({counts})</span>
        </h6>
      </div>

      <Row className="gx-4 gy-4">
        {products.map(product => (
          <Col
            key={product._id}
            className="custom-col-5"
            style={{ flex: '0 0 20%', maxWidth: '20%' }}
          >
            <ProductCardCat product={product} setProduct={() => {}} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default EcomCategoriesWisePorduct;
